import {useHandleApiError, useAxios} from '@sttedra_ui/framework';
import MapBaseApiModel from './mapBase.api-model';

/**
 * @typedef {import("@sttedra_ui/framework").AxiosErrorDataModel} AxiosErrorDataModel
 */

// #region Globals
const CONTEXT_BASE_PATH = 'MapBase';
const {base} = useAxios();
const {handleApiError} = useHandleApiError();
// #endregion

async function getMapBases() {
  try {
    const url = `/${CONTEXT_BASE_PATH}`;

    const {data} = await base
      .get(url, {
        timeout: 5000,
      });

    return data.map((mapBase) => new MapBaseApiModel(mapBase));
  } catch (err) {
    return handleApiError(err);
  }
}

async function getCapabilitiesByName(name) {
  try {
    const url = `/${CONTEXT_BASE_PATH}/BaseMapCapabilitiesByName`;

    const {data} = await base
      .get(url, {
        params: {name},
        timeout: 5000,
      });

    return data;
  } catch (err) {
    return handleApiError(err);
  }
}

// #endregion

// #region Private functions
// #endregion

export {
  getMapBases,
  getCapabilitiesByName,
};
